<script setup lang="ts">
import { PhxsgHeading as PhxsgCoreHeading, PhxsgHeadingProps } from '@sg-core/src/View/Components/Atoms/Heading';

type HeadingColor = 'primary' | 'secondary' | 'subtle' | 'muted';

const { use = 'h2', color = 'primary' } = defineProps<PhxsgHeadingProps & { color?: HeadingColor }>();
</script>

<template>
  <PhxsgCoreHeading
    :use="use"
    :variant="variant"
    :align="align"
    :wrap="wrap"
    :uppercase="uppercase"
    :class="[
      {
        [`phxsg-${variant}`]: variant,
        'phxsg-text--secondary': color === 'secondary',
        'phxsg-text--subtle': color === 'subtle',
        'phxsg-text--muted': color === 'muted',
      },
    ]"
  >
    <slot />
  </PhxsgCoreHeading>
</template>

<style src="../Text/text.css" />
<style src="./heading.css" />
